import React from "react";
import "./BoxEffect.css";
interface BoxEffectProps{
    isActive:boolean;
    delay:number;
}

const BoxEffect:React.FC<BoxEffectProps> = (props) => {
    return(
        <div className={"BoxEffectBase"}>
            <div className={"BoxEffect " + (props.isActive ? "Active" : "InActice")} style={{transitionDelay:props.delay + "s"}}/>
                {props.children}
        </div>
    );
};

export default BoxEffect;